import { render } from "./CusInput.vue?vue&type=template&id=438fd02b&scoped=true"
import script from "./CusInput.vue?vue&type=script&lang=js"
export * from "./CusInput.vue?vue&type=script&lang=js"

import "./CusInput.vue?vue&type=style&index=0&id=438fd02b&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438fd02b"]])

export default __exports__